import { updateItems } from '@/mocks/homepage';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10 flex-wrap gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              最新爆料快讯
            </h2>
            <p className="text-sm text-foreground-500 mt-1">实时追踪全网网红动态，不错过任何大瓜</p>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-foreground-400">
            <div className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></div>
            实时更新中
          </div>
        </div>
        <div className="max-w-3xl mx-auto">
          {updateItems.map((item, index) => (
            <div key={item.id} className="relative flex gap-4">
              {index !== updateItems.length - 1 && (
                <div className="absolute left-[19px] top-10 bottom-0 w-px bg-background-300"></div>
              )}
              <div className="relative z-10 mt-1">
                <div className="w-[38px] h-[38px] rounded-full bg-primary-500 flex items-center justify-center shrink-0">
                  <span className="text-xs font-bold text-background-50">{index + 1}</span>
                </div>
              </div>
              <div className="flex-1 pb-8">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className="text-xs text-foreground-300">·</span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 leading-relaxed">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}